import { EvCar, GochargeCardEv } from "@/models/common";
import {
  Car,
  CarOrder,
  GxFilter,
  NOT_REGISTERED,
  REGISTERED,
  WITHIN_PERIOD,
} from "@/models/vehicle";
import { getJSTTime } from "@/util/datetime";

export const VehicleConstants = {
  BasicInfomation: "基本情報",
  Vehicle: "車両",
  CompanyOffice: "会社／営業所",
  RadioNumber: "無線番号",
  PlateNumber: "ナンバープレート",
  CarModelName: "車種名",
  ChargingPlanSystem: "充電計画システム",
  ResidualPowerPercent: "残電力量(%)",
  SocLastCollectedAt: "残電力量収集日時",
  SmartDisplay: "スマート表示",
  SmartDisplayTooltip: "1時間以内の日時を ◯分前 の表記に切り替える",
  FullChargeCapacity: "満充電容量(%)",
  WorkCycle: "勤務サイクル",
  Front: "表",
  Rear: "裏",
  EVModel: "EV車種",
  EVModelName: "EV車種名",
  ChargePlanningSystemUsageStartDate: "充電計画システム利用開始日",
  ChargePlanningSystemUsageEndDate: "充電計画システム利用終了日",
  ChargeCardControlNumber: "充電カード管理番号",
  ChargeCardRemarks: "充電カード備考",
  GochargeCard: "GO Charge充電カード",
  GochargeCardStartOn: "開始日",
  GochargeCardEndOn: "終了日",
  SocAcquisitionInformation: "バッテリー残量取得情報",
  MoTDeviceSerialNumber: "MoTデバイスシリアル番号",
  IMEI: "IMEI",
  IMEI2: "交換予定IMEI",
  IMEIErrorMessage: "15桁の数字を入力してください",
  IMEIUpdateCaution: "※車両とOBDⅡ端末（IMEI：OBDⅡ端末の番号）の紐付けを変更する場合は、無線番号を変更してください",
  VIN: "VIN",
  SettingFile: "車両設定ファイル",
  SettingFileUpload: "車両設定ファイルアップロード",
  SelectSettingFile: "ファイルを選択",
  Edit: "車両編集",
  Detail: "車両詳細",
  Subsidy: "補助金区分",
  PeriodWarning:
    "システム利用開始から6年未満です。本当に解約しますか？6年未満で解約された場合、最低充電電力量を乗じた金額を請求してください。",
  SocInformation: "バッテリー残量情報",
  RemainingCharge: "残充電量(%)",
  Percent: "%",
  Using: "利用中",
  NotYet: "―",
  NoConfig: "設定なし",
  Confirm: "更新確認",
  FrontBaseDate: "基準日（表）",
  FrontApplyOn: "適用開始日",
  BackBaseDate: "基準日（裏）",
  BackApplyOn: "適用開始日（裏）",
  NumberOfCars: "稼働台数カウント",
  Include: "対象",
  Exclude: "対象外",
  ParkingLot: "駐車場所",
  PreviousCar: "切替元車両",
} as const;

export const PAGE_SIZE = 30;

export const UsingGxFilter: GxFilter[] = [
  {
    type: REGISTERED,
    display: "登録済み",
  },
  {
    type: WITHIN_PERIOD,
    display: "利用期間内",
  },
  {
    type: NOT_REGISTERED,
    display: "未登録",
  },
];

export const DefaultOrder: CarOrder = {
  officeDisplayName: "asc",
  vehicleCode: "asc",
};

export const getVehicleCodeLabel = (car?: Car) =>
  car != null ? `${car.vehicleCode ?? ""} (car_id:${car.id})` : "";

export const getVehicleCodeAndEvCarLabel = (car?: Car) =>
  car != null
    ? `${car.vehicleCode} (car_id:${car.id}, ev_car_id: ${car.evCars?.id ?? ""})`
    : "";

export const lastCollectedAt = (
  format: "short" | "full",
  lastCollectedAt?: string
) => {
  // EV車両が紐づいていない場合は空
  if (lastCollectedAt == null) {
    return "";
  }

  const time = new Date(lastCollectedAt);
  const diff = time.getTime() - Date.now();

  // 最終収集日時が24時間以上未来だったら"ー"を表示させる
  return diff > 24 * 60 * 60 * 1000
    ? "ー"
    : lastCollectedAt
      .replace(/-/g, "/")
      .replace("T", " ")
      .slice(format === "short" ? 2 : 0, 19);
};

export const getGochargeCardLabel = (gochargeCardEv?: GochargeCardEv) => {
  const cardNo = gochargeCardEv?.gochargeCards?.externalChargeCardNo;
  const startOn = gochargeCardEv?.startOn;
  const endOn = gochargeCardEv?.endOn;

  if (!cardNo || !startOn) {
    return "";
  }

  const period = endOn
    ? `${startOn.replace(/-/g, "/")}〜${endOn.replace(/-/g, "/")}`
    : `${startOn.replace(/-/g, "/")}〜`;

  return `${cardNo}（${period}）`;
};

export const getSetPreviousCarWarnMessage = (evCar: Partial<EvCar>) => {
  const endAt = (() => {
    const date = new Date(
      evCar?.usageStartOn?.length ? evCar.usageStartOn : Date.now()
    );
    date.setDate(date.getDate() - 1);
    return date;
  })();

  return `切替元車両の利用終了日を${getJSTTime(endAt, "date").replace(
    /-/g,
    "/"
  )}に変更します。\nまた、この車両の切替元車両の変更は今後はできません。\nIMEIの変更漏れ、充電カードの解除漏れにご注意ください。`;
};
